module.exports = __webpack_public_path__ + "img/default-avatar.502b3c8b.png";